import React from 'react';
import { BadgeProps } from './Badge.types';
import clsx from 'clsx';

export const Badge: React.FC<BadgeProps> = ({
  badgeVariation,
  badgeText,
  className,
  isInlineMerch = false,
  badgeIcon,
  customClass = '',
  tabIndex,
  id,
  role,
}) => {
  return (
    <>
      {badgeVariation === 'inline' && (
        <span
          data-component-name="a-ui-library-Badge"
          data-testid="ui-library-Badge"
          className={clsx(
            className,
            't-overline-normal',
            isInlineMerch ? 'm-badge-inline-merch' : 'm-badge-inline',
            customClass
          )}
          id={id}
          tabIndex={tabIndex}
        >
          {badgeText}
        </span>
      )}
      {badgeVariation === 'overlay' && (
        <div
          data-component-name="a-ui-library-Badge"
          data-testid="ui-library-Badge"
          className={clsx(className, 'm-badge-overlay-merch t-overline-normal', customClass)}
          id={id}
          tabIndex={tabIndex}
          role={role}
        >
          {badgeIcon && <span className={badgeIcon}></span>}
          {badgeText}
        </div>
      )}
    </>
  );
};
